function i(e) {
  if (e == null) return null;
  const r = Array.isArray(e) ? e : e.split(",");
  return new Set(r.map((o) => o.trim()).filter(Boolean));
}
function p(e, r) {
  return r === null ? !0 : r.has(e);
}
function a(e) {
  const { teacherTotter: r } = e.providers;
  if (r?.enabled && !r.syncUrl)
    throw new Error("[analytics] teacher-totter is enabled but no syncUrl was provided.");
  return {
    app: e.app,
    environment: e.environment,
    providers: e.providers,
    enabledGroups: i(e.enabledFeatureGroups),
    events: e.events,
    debug: e.debug ?? !1
  };
}
class c {
  constructor(r, o) {
    this.config = r, this.providers = o, this.commonProps = {
      mx_app: r.app,
      mx_env: r.environment,
      mx_locale: "",
      mx_country_code: "",
      mx_user_profile_id: "",
      mx_user_profile_type: "unknown",
      mx_market_region_id: ""
    }, this.providers.forEach((s) => s.init());
  }
  setCommonProps(r) {
    this.commonProps = {
      mx_app: this.config.app,
      mx_env: this.config.environment,
      mx_locale: r.locale,
      mx_country_code: r.countryCode,
      mx_user_profile_id: r.userProfileId,
      mx_user_profile_type: r.userProfileType,
      mx_market_region_id: r.marketRegionId
    }, this.providers.forEach((o) => o.setCommonProps(this.commonProps));
  }
  identify() {
    const r = this.commonProps.mx_user_profile_id;
    this.providers.forEach((o) => o.identify(r, this.commonProps));
  }
  track(r, o) {
    const s = this.config.events[r];
    if (!s) {
      this.config.debug && console.warn(`[analytics] Unknown event "${r}" not in the event map; skipping.`);
      return;
    }
    const n = {
      name: r,
      group: s.group,
      props: o,
      commonProps: this.commonProps
    };
    this.providers.forEach((t) => {
      t.isGroupGated && !p(n.group, this.config.enabledGroups) || t.track(n);
    });
  }
  trackSession(r) {
    this.providers.forEach((o) => o.trackSession?.(r));
  }
  shutdown() {
    this.providers.forEach((r) => r.shutdown());
  }
}
export {
  c as A,
  p as i,
  i as p,
  a as r
};



// WEBPACK FOOTER //
// ./~/@3plearning/mx-teacher-analytics/dist/analytics-client-BKLFpCLd.js